export const HTTP_HEADER = {
  AUTHORIZATION: 'Authorization',
} as const;

export type HttpHeaderName = (typeof HTTP_HEADER)[keyof typeof HTTP_HEADER];

export const BEARER_TOKEN_PREFIX = 'Bearer';
